<div class="z-20 fixed inset-0 flex items-center justify-center bg-main-background bg-opacity-75"
    (click)="$event.preventDefault(); handleCloseStudentCases();"
>
    <div class="max-h-screen w-full flex flex-col items-center justify-center overflow-hidden">
        <div class="w-full max-w-screen-md flex flex-col my-6 p-8 gap-4 bg-white rounded-md shadow-lg overflow-hidden max-h-[80vh] overflow-y-auto" (click)="$event.stopPropagation()">

            <div class="w-full flex flex-row gap-8 items-center justify-between pb-4">
                <ng-container *ngIf="studentCases.length > 0; else emptyStudentCasesTitle" class="w-full">
                    <h2 class="w-full text-[#f15f3e] oswald-font text-xl font-medium text-start">
                        The following cases have been identified for this student.<br>For further information, please reach out to the associated district.
                    </h2>
                </ng-container>
                <ng-template #emptyStudentCasesTitle class="w-full">
                    <h2 class="w-full text-[#f15f3e] oswald-font text-xl font-medium text-start">
                        No case has been identified for this student.<br>For further information, please reach out to the associated district.
                    </h2>
                </ng-template>
            </div>
            <ng-container *ngIf="studentCases.length > 0; else emptyStudentCases" class="w-full h-full flex flex-col items-center gap-2 pb-4">
                <div class="w-full flex flex-col items-center text-start">
                    <table class="w-full text-left">
                        <thead class="oswald-font text-gray-700 uppercase bg-main-background">
                            <tr>
                                <th scope="col" class="px-6 py-3">District</th>
                                <th scope="col" class="px-6 py-3">Case</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let case of studentCases" class="bg-white border-b">
                                <th scope="row" class="px-6 py-4 font-medium text-gray-900 whitespace-nowrap">
                                    {{ case.building_name}}
                                </th>
                                <td class="px-6 py-4">{{ case.case_id }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </ng-container>
            
            <ng-template #emptyStudentCases>
                <div class="w-full text-nside-gray-100 italic">
                    Empty Assessments Cases
                </div>
            </ng-template>
            <div class="w-full flex flex-row gap-2 items-center justify-end">
                <div class="w-full flex flex-row gap-2 items-center justify-end">
                    <button 
                        (click)="$event.preventDefault(); handleCloseStudentCases();"
                        class="px-4 py-1.5 w-20 rounded-md border border-nside-gray-400 oswald-font"
                    >
                        Close
                    </button>
                    <button
                        (click)="$event.preventDefault(); createNewAssessScreen();"
                        class="flex items-center justify-center px-2.5 py-1.5 rounded-md border bg-gradient-to-b oswald-font text-white border-nside-orange-100 from-nside-orange-300 to-nside-orange-400 hover:bg-gradient-to-b hover:from-nside-orange-100 hover:to-nside-orange-200"
                    >
                        Proceed to Creating New Assess Case
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>

<div *ngIf="loading">
    <spinner></spinner>
</div>

<popup-message 
    [type]="messageModal"
    (close)="resetMessageModal()"
    [message]="popupMessage"
></popup-message>
